import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, ButtonBase, Typography } from "@mui/material";
import LogoSection from "../LogoSection";
import ProfileSection from "./ProfileSection";
import { IconMenu2 } from "@tabler/icons";
import { color } from "../../../utils/color"; // <-- adjust path if needed
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const UserType = {
  Admin: "Admin",
  User: "User",
  Staff: "HOD",
  GateKeeper: "Gatekeeper",
};

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();

  const { i18n, t } = useTranslation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("");
  const navigate = useNavigate();
  const [language, setLanguage] = useState(localStorage.getItem("lang"));

  useEffect(() => {
    if (!language) {
      const defaultLang = "en"; // Or 'en'
      setLanguage(defaultLang);
      i18n.changeLanguage(defaultLang);
      localStorage.setItem("lang", defaultLang);
    }
  }, [language, i18n]);

  const toggleLanguage = (value) => {
    const lang = value;
    i18n.changeLanguage(lang);
    setLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  async function getUserProfile() {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}staff/details`, {
        headers: {
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (result.code === 200) {
        setName(result?.data?.name);
        setEmail(result?.data?.email);
        setType(result?.data?.type);
      } else if (result.code === 201) {
        localStorage.clear();
        navigate("/");
      }
    } catch (error) {
      navigate("/");
    }
  }
  useEffect(() => {
    getUserProfile();
  }, []);

  return (
    <>
      {/* header container */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          //   backgroundColor: color.fg, // ✅ background color from file
          //   color: color.fg, // ✅ foreground/text color
          px: 2,
          py: 1,
        }}
      >
        {/* logo & toggler button */}
        <Box
          sx={{
            width: 228,
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down("md")]: {
              width: "auto",
            },
          }}
        >
          <Box component="span" sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }}>
            <LogoSection />
          </Box>

          <ButtonBase
            sx={{ borderRadius: "12px", overflow: "hidden", border: `1px solid ${color.bg}` }}
          >
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: "all .2s ease-in-out",
                background: color.fg, // swapped colors
                color: color.bg,

                "&:hover": {
                  background: color.bg,
                  color: color.fg,
                },
              }}
              onClick={handleLeftDrawerToggle}
              color="inherit"
            >
              <IconMenu2 stroke={1.5} size="1.3rem" />
            </Avatar>
          </ButtonBase>
        </Box>

        {/* spacing */}
        <Box sx={{ flexGrow: 1 }} />

        {type && (
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            {UserType[type] || type}
          </Typography>
        )}

        {/* language toggle */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            marginInline: "1rem",
            border: `1px solid ${color.bg}`,
            borderRadius: "8px",
            padding: "0.25rem",
            background: "#f5f5f5",
          }}
        >
          <button
            onClick={() => toggleLanguage("en")}
            style={{
              padding: "0.375rem 0.75rem",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              fontWeight: language === "en" ? "600" : "400",
              background: language === "en" ? color.hv : "transparent",
              color: language === "en" ? color.bg : "#666",
              transition: "all 0.2s ease-in-out",
            }}
          >
            EN
          </button>
          <button
            onClick={() => toggleLanguage("ar")}
            style={{
              padding: "0.375rem 0.75rem",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              fontWeight: language === "ar" ? "600" : "400",
              background: language === "ar" ? color.hv : "transparent",
              color: language === "ar" ? color.bg : "#666",
              transition: "all 0.2s ease-in-out",
            }}
          >
            AR
          </button>
        </div>

        {/* profile section */}
        <ProfileSection name={name} email={email} type={type} />
      </Box>
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
};

export default Header;
